import { Component, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { AuthService } from '../services';
import { Storage } from '@ionic/storage';
import ErrorHandler from '../../lib/error-handler';
import { LoadingModal } from '../loading-modal/loading-modal';
import { waitForClerk } from '../types/clerk-shim';

declare var Penmate;

@Component({
  selector: 'pm-clerk-signup-modal',
  templateUrl: 'clerk-signup-modal.html',
  styleUrls: ['./clerk-signup-modal.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ClerkSignUpModal implements AfterViewInit, OnDestroy {
  loading = false;
  clerkInstance: any;
  
  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    public modalCtrl: ModalController,
    private authService: AuthService,
  ) {}

  async ngAfterViewInit() {
    try {
      this.loading = true;
      // Wait for Clerk to be available from CDN (already initialized)
      this.clerkInstance = await waitForClerk();
      
      // Mount the Clerk sign-up UI
      const signUpDiv = document.getElementById('clerk-signup');
      if (signUpDiv) {
        // mountSignUp returns a promise that resolves when mounted
        await this.clerkInstance.mountSignUp(signUpDiv, {
          redirectUrl: `${Penmate.env.rootUrl}/login`,
          fallbackRedirectUrl: `${Penmate.env.rootUrl}/login`,
        });
        
        // Set loading to false after mount completes
        this.loading = false;
        
        // Listen for successful sign-up
        this.clerkInstance.addListener(this.handleClerkAuth);
      } else {
        // No div found, stop loading
        this.loading = false;
        console.error('Clerk sign-up div not found');
      }
    } catch (error) {
      this.loading = false;
      ErrorHandler.captureException(error, 'Clerk initialization error');
      console.error('Failed to initialize Clerk:', error);
    }
  }

  handleClerkAuth = async (emission: any) => {
    if (!emission.user) return;

    console.log("@@@ GOT CLERK AUTH EMMISSION -->", emission);
    
    try {
      this.loading = true;
      const loadingModal = await this.modalCtrl.create({
        component: LoadingModal,
        componentProps: { message: 'Creating account...' },
      });
      await loadingModal.present();
      
      // Get the current session
      const session = emission.session || this.clerkInstance.session;
      if (!session) {
        await loadingModal.dismiss();
        this.loading = false;
        return;
      }
      
      // Send session ID to backend for authentication
      this.authService.apiClient.post(
        `${Penmate.env.apiUrl}/login?type=web`,
        {},
        { clerk: session.id }
      ).subscribe(
        async (data) => {
          // Store auth token
          await this.storage.set('id_token', data.auth_token);
          await this.storage.set('user', data.user);
          
          // Store Clerk sign-in token if provided
          if (data.sign_in_token) {
            await this.storage.set('clerk_sign_in_token', data.sign_in_token);
          }
          
          await loadingModal.dismiss();
          this.loading = false;
          
          // Note: Clerk will handle the redirect after successful sign up
          // We don't need to manually navigate since Clerk redirects to the configured URL
        },
        async (error) => {
          await loadingModal.dismiss();
          this.loading = false;
          ErrorHandler.captureMessage('Sign Up Error: Clerk', { error });
          console.error('Sign up error:', error);
        }
      );
    } catch (error) {
      this.loading = false;
      ErrorHandler.captureException(error, 'Clerk auth handling error');
    }
  };

  ngOnDestroy() {
    // Clean up Clerk listeners
    if (this.clerkInstance) {
      this.clerkInstance.removeListener(this.handleClerkAuth);
      this.clerkInstance.unmountSignUp('#clerk-signup');
    }
  }

  cancel() {
    this.navCtrl.navigateForward('/login');
  }
}